module.exports = __webpack_public_path__ + "static/18-b0e785a6205035c619d28e9df42953b7.jpg";